<template>
  <div ref="popover" class="popover bs-tether-element bs-tether-element-attached-top bs-tether-element-attached-center bs-tether-target-attached-bottom bs-tether-target-attached-center fade bs-tether-enabled show">
    <div class="popover-content">
      <div class="category-area">
        <ul class="list-group">
          <!-- 第一階層-->
          <template v-for="category in event.categories">
            <router-link tag="li" @click.native="selectCategory" :to="{ query: { firstCategoryId: category.id }}" append class="list-group-item first-level">{{category.name}}</router-link>
            <!-- 第二階層-->
            <template v-for="category2 in category.children">
              <router-link tag="li" @click.native="selectCategory" :to="{ query: { firstCategoryId: category.id,secondCategoryId:category2.id }}" append class="list-group-item second-level">{{category2.name}}</router-link>
              <!-- 第三階層-->
              <template v-for="category3 in category2.children">
                <router-link tag="li" @click.native="selectCategory" :to="{ query: { firstCategoryId: category.id,secondCategoryId:category2.id, thirdCategoryId:category3.id}}" append class="list-group-item third-level">{{category3.name}}</router-link>
              </template>
            </template>
          </template>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  import {dd,store,app} from 'systems/imports'

  export default {
    name:"",
    components: {
    },
    props:["event"],
    data () {
      return {
      }
    },
    created(){
    },
    methods:{
      selectCategory(){
        this.$emit("selectCategory")
      }
    }
  }
</script>


<style lang="scss" scoped>
  .popover{
    border:none;
    .popover-content{
      padding:0;
    }
  }
  .category-area {
    min-width: 50vw;
    .list-group-item {
      border-radius: 0 !important;
      cursor: pointer;
      font-size: 0.8rem;
      padding: 8px 16px;
      &.first-level {
        color: #453e4f;
        font-weight: bold;
        background-color: #c1df86;
        position: relative;
        &:after {
          font-family: FontAwesome;
          content: '\f054';
          font-size: 1.2rem;
          color: #81ba1c;
          position: absolute;
          top: 50%;
          transform: translateY(-50%) translateX(0);
          right: 5%;
        }
      }
      &.second-level {
        color: #5f5f5e;
        background-color: #f8ffeb;
      }
      &.third-level {
        color: #5f5f5e;
        background-color: #f8ffeb;
      }
    }
  }
  .popover.popover-bottom, .popover.bs-tether-element-attached-top{
    margin-top: 5px;
  }
  .popover.bs-tether-element-attached-top::after,
  .popover.bs-tether-element-attached-top::before{
    border:none;
  }
</style>



// WEBPACK FOOTER //
// CategoryPopover.vue?595fb728